















import { Component, Vue, Prop } from "vue-property-decorator";
import CollectionEventDetails from "@/components/CollectionEvents/CollectionEventDetails.vue";

@Component({ components: { CollectionEventDetails } })
export default class CollectionEventDetailsDialog extends Vue {
  @Prop(Boolean) readonly value: boolean = false;
  @Prop(Number) readonly collectionEventId?: number;
  @Prop(Boolean) readonly isCollectionIssue?: boolean;
  @Prop(Number) readonly collectionEventType: number | undefined;

  close() {
    this.$emit("input", false);
  }

  onLoadDetailsError() {
    this.$emit("input", false);
  }
}
